export const booleanValueMapper = ({ value }: { value: any }) => !!value;

booleanValueMapper.displayName = 'booleanMapper';
